import dayjs from 'dayjs'
import { IAPIImportDto, IWalletDto, IntegrationType } from './dtos'
import { IAPIImport, IAuthImport, IIntegration, IWallet } from './models'

export const mapIntegrationFromDto = ({
	id,
	progress,
	integrationType,
	syncStatus,
	errorCode,
	name,
	fileName,
	exchangeName,
	totalTransactionsCount,
	integratedTransactionsCount,
	integrationStartDate,
	wallets,
	source,
	integrationsToday,
	externalProviderLastTransactionId,
}: IntegrationType): IIntegration => ({
	id,
	progress,
	sourceType: integrationType,
	status: syncStatus,
	error: errorCode,
	name: fileName || name || exchangeName || source || '',
	total: totalTransactionsCount,
	integrated: integratedTransactionsCount,
	integrationStartedAt: dayjs(integrationStartDate, 'YYYY-MM-DDTHH:mm:ss').toDate(),
	walletIds: wallets,
	source,
	syncAllowed: integrationsToday,
	lastTransactionId: externalProviderLastTransactionId,
	// mock for later pulling
	wallets: [],
})

export const mapAPIIntegrationToDto = (params: IAPIImport | IAuthImport): IAPIImportDto => {
	if ('apiKey' in params) {
		return {
			apiKeys: {
				accessKey: params.apiKey,
				secretKey: params.apiSecret,
				passphrase: params.passphrase,
			},
			exchange: params.integration,
		}
	}

	return {
		authCode: {
			authCode: params.authCode,
			redirectUrl: params.redirectUrl,
		},
		exchange: params.integration,
	}
}

export const mapWalletFromDto = (dto: IWalletDto): IWallet => {
	return {
		id: dto.id,
		address: dto.address || undefined,
		balances: dto.balance.map(({ asset, internalValue, internalAmount, externalAmount }) => ({
			currency: asset,
			amount: internalAmount,
			value: internalValue,
			externalAmount: externalAmount,
		})),
		name: dto.name,
		transactions: dto.transactions,
		properties: dto.properties,
		type: dto.type,
	}
}
